const destinations = [
  { flag: "🇩🇪", country: "Germany", city: "Frankfurt / Munich", angle: "ETSU exchange programs, medical research, Appalachian manufacturing partner visits", distance: "Flies via Charlotte (CLT) or Atlanta (ATL)" },
  { flag: "🇬🇧", country: "United Kingdom", city: "London / Edinburgh", angle: "Ballad Health international conferences, ETSU academic partnerships, Mountain States research", distance: "Flies via Washington Dulles (IAD) or Charlotte" },
  { flag: "🇨🇦", country: "Canada", city: "Toronto / Montreal", angle: "Business travel, academic conferences, and family vacations — passport required even for land border crossings", distance: "Flies via Charlotte (CLT)" },
  { flag: "🇲🇽", country: "Mexico", city: "Cancún / Mexico City", angle: "Johnson City family beach vacations, medical tourism, and Washington County winter escapes", distance: "Flies via Atlanta (ATL)" },
  { flag: "🇯🇵", country: "Japan", city: "Tokyo / Osaka", angle: "ETSU research faculty, Tennessee technology partnerships, and regional manufacturers visiting Japanese facilities", distance: "Flies via Atlanta (ATL) or Chicago (ORD)" },
  { flag: "🇫🇷", country: "France", city: "Paris / Lyon", angle: "ETSU arts programs, culinary tourism, European medical conference travel from Northeast Tennessee", distance: "Flies via Charlotte or Dulles" },
  { flag: "🇨🇷", country: "Costa Rica", city: "San José / Liberia", angle: "Eco-tourism from the Appalachian outdoors community, ETSU environmental research programs, family vacations", distance: "Flies via Atlanta (ATL)" },
  { flag: "🇪🇸", country: "Spain", city: "Madrid / Barcelona", angle: "ETSU study abroad flagship program, cultural tourism, and Northeast Tennessee travelers connecting via European hubs", distance: "Flies via Charlotte or Dulles" },
];

export default function JohnsonCityDestinationsSection() {
  return (
    <section id="destinations" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Popular Destinations</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Johnson City Travelers Are Going
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From ETSU study abroad programs to Ballad Health international conferences — here are the most common international destinations for Tri-Cities travelers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {destinations.map((dest, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-xl p-6 hover:bg-white border border-transparent hover:border-[#F6C344] transition-all group">
              <div className="text-4xl mb-4">{dest.flag}</div>
              <h3 className="font-serif font-bold text-[#1A365D] text-lg mb-1">{dest.country}</h3>
              <p className="text-[#F6C344] font-semibold text-sm mb-3">{dest.city}</p>
              <p className="text-gray-500 text-xs leading-relaxed mb-3">{dest.angle}</p>
              <div className="flex items-center gap-1.5 text-xs text-gray-400">
                <i className="ri-flight-takeoff-line text-[#1A365D]"></i>
                <span>{dest.distance}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#F7F8FA] rounded-xl p-8 text-center">
          <h3 className="font-serif text-2xl font-bold text-[#1A365D] mb-3">Flying from Tri-Cities Regional (TRI)?</h3>
          <p className="text-gray-500 max-w-2xl mx-auto text-sm leading-relaxed mb-6">
            TRI connects Johnson City travelers to Charlotte (CLT), Atlanta (ATL), Washington Dulles (IAD), and Chicago (ORD) — all major international departure hubs. A valid US passport is required at those connecting airports for international boarding.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] text-[#1A365D] font-semibold px-8 py-3 rounded-lg hover:bg-[#e5b33f] transition-all whitespace-nowrap"
          >
            <i className="ri-passport-line"></i>
            Start Your Application
          </a>
        </div>
      </div>
    </section>
  );
}